import { LegalPage } from "../../components/LegalPage";

export function Accessibility() {
  return (
    <LegalPage
      title="Accessibility Statement"
      description="WeConsult Rx accessibility commitment to WCAG 2.1 AA across the marketing site and the PWA."
      path="/accessibility"
      effective="2026-05-30"
    >
      <p>
        WeConsult Rx is committed to accessibility for users with disabilities.
        We target Web Content Accessibility Guidelines (WCAG) 2.1 Level AA
        across this marketing site and the PWA at app.weconsultrx.com.
      </p>

      <h2>What we do</h2>
      <ul>
        <li>Semantic HTML5 landmarks (header / main / nav / footer / article).</li>
        <li>Skip-to-content link on every page.</li>
        <li>Custom focus indicators with 4.5:1 contrast against background.</li>
        <li>Keyboard navigation for all interactive elements (including menus and forms).</li>
        <li>Labels on every form input. Errors announced inline.</li>
        <li>Alt text on every meaningful image.</li>
        <li><code>prefers-reduced-motion</code> respected.</li>
        <li>Color contrast 4.5:1 minimum on body text; 3:1 on UI elements.</li>
        <li>No content flashing more than 3 times per second.</li>
      </ul>

      <h2>Tooling</h2>
      <p>
        We test with axe-core, manual keyboard navigation, and screen reader
        spot-checks (VoiceOver, NVDA) on critical flows. Lighthouse
        accessibility audits run on every release.
      </p>

      <h2>Known limitations</h2>
      <ul>
        <li>Some auto-rendered PDF documents (recommendation bundles) may have limited tag structure. We are improving this.</li>
        <li>Signing happens in the platform, so its accessibility is ours to own — not deferred to a third-party widget. Any remaining third-party embed is governed by its own accessibility statement.</li>
      </ul>

      <h2>Feedback</h2>
      <p>
        If you find a barrier, please email accessibility@weconsultrx.com.
        We will respond within five business days.
      </p>
    </LegalPage>
  );
}
